import React from 'react';
import Immutable from 'immutable';
import {
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphContactPerson = ({ id, entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);

  return (
    <Container id={id} className="Paragraph ParagraphContactPerson">
      <div className="row">
        <div className="ParagraphContactPerson__inner col-12 col-md-10 col-lg-8">
          {title && (
            <h3 className="ParagraphContactPerson__title">{title}</h3>
          )}
          <WysiwygField
            property="schema:text"
            className="ParagraphContactPerson__body"
            html={body}
          />
          {entity.getIn(['field_person'], Immutable.List()).map((item) => {
            const person = item.get('entity');
            const pbody = person.getIn(['field_body', 0, 'value']);
            const name = person.getIn(['title', 0, 'value']);
            const func = person.getIn(['field_function', 0, 'value']);
            const image = person.getIn(['field_media_item', 0, 'styles', 'paragraph_contact_person']);
            const link = person.getIn(['field_link', 0, 'uri']);
            const linkTitle = person.getIn(['field_link', 0, 'title']);

            return (
              <>
                <div className="ParagraphContactPerson__wrapper">
                  <div className="ParagraphContactPerson__block">
                    <Image
                      src={image}
                      className="ParagraphContactPerson__image"
                    />
                  </div>
                  <div className="ParagraphContactPerson__block">
                    <h4 className="ParagraphContactPerson__name">{name}</h4>
                    {func && (
                      <div className="ParagraphContactPerson__function">{func}</div>
                    )}
                    {pbody && (
                      <p className="ParagraphContactPerson__description tablet">{pbody}</p>
                    )}
                    {link && linkTitle && (
                      <a className="ParagraphContactPerson__link tablet" href={link}>{linkTitle}<div className="icon icon-arrow-right icon-variant-2" /></a>
                    )}
                  </div>
                </div>
                {pbody && (
                  <p className="ParagraphContactPerson__description mobile">{pbody}</p>
                )}
                {/* {link && linkTitle && (
                  <a className="ParagraphContactPerson__link mobile" href={link}>{linkTitle}<div className="icon icon-arrow-right icon-variant-2" /></a>
                )} */}
              </>
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default ParagraphContactPerson;
